/**
 * Control Components
 *
 * Standalone, reusable control components that can be placed in any layout slot.
 */

export {AxisRangeControl, type AxisRangeControlProps} from './AxisRangeControl';
export {CaptionControl, type CaptionControlProps} from './CaptionControl';
export {IndexSlider, type IndexSliderProps} from './IndexSlider';
export {Pagination} from './Pagination';
export {StepSlider, type StepSliderProps} from './StepSlider';
export {TileTitle, type TileTitleProps} from './TileTitle';
